import { MutationCache, QueryClient } from '@tanstack/react-query';
import { logger } from '@waitroom/logger';

export const defaultErrorHandler = <T = unknown>(error: T) => {
  logger.report(error);
};

const mutationCache = new MutationCache({
  onError: defaultErrorHandler,
});

export const queryClient = new QueryClient({
  defaultOptions: {},
  mutationCache,
});
